import React, { Component } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import CircularLoader from "../../../../components/loaders/circularLoader";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch";

const THEME = {
  primary: "#3b82f6",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  text: "#0f172a",
  textMuted: "#64748b",
  border: "#e2e8f0",
  bgCard: "#ffffff",
  bgLight: "#f8fafc",
};

// GraphQL Queries & Mutations
const GET_UNASSIGNED_AND_ASSIGNED_LEADS = gql`
  query getUnassignedAndAssignedLeads($instituteId: Int!, $branchId: Int!) {
    getUnassignedAndAssignedLeads(institute_id: $instituteId, branch_id: $branchId) {
      unAssigned_Leads {
        lead_id
        lead_name
        lead_mobile
        source_name
        employee_id
        employee_name
      }
      assigned_Leads {
        lead_id
        lead_name
        lead_mobile
        source_name
        employee_id
        employee_name
      }
    }
  }
`;

const GET_LEAD_MANAGEMENT_EMPLOYEES = gql`
  query getLeadManagementEmployees($instituteId: Int!, $branchId: Int!) {
    getLeadManagementEmployees(institute_id: $instituteId, branch_id: $branchId) {
      employee_id
      employee_name
      emp_mobile
      assigned_status
    }
  }
`;

const ADD_OR_DELETE_LEADS = gql`
  mutation addOrDeleteLeads($params: AddOrDeleteLeads!) {
    addOrDeleteLeads(params: $params)
  }
`;

const GET_LEAD_STATUS_TYPES = gql`
  query getLeadStatusTypes($instituteId: Int!) {
    getLeadStatusTypes(institute_id: $instituteId) {
      id
      lead_status_type
    }
  }
`;

class TagsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unassignedLeads: [],
      assignedLeads: [],
      employees: [],
      statusTypes: [],
      status: "idle",
      error: null,
      selectedTags: null,
      selectedLeadStatus: "unassigned",
      selectedLeads: [], // Array of lead_ids
      selectedEmployee: null,
      assigning: false,
      snackbar: {
        open: false,
        message: "",
        severity: "success",
      },
      isMobile: window.innerWidth <= 600,
    };
  }

  componentDidMount() {
    this.fetchData();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 600 });
  };

  fetchData = async () => {
    const { client } = this.props;
    const institutionId = Cookies.get("institutionid");
    const branchId = Cookies.get("branch_id");

    if (!institutionId || !branchId) {
      console.warn("Missing institutionid or branch_id cookies", { institutionId, branchId });
      this.setState({ status: "succeeded", unassignedLeads: [], assignedLeads: [] });
      return;
    }

    const instId = parseInt(institutionId);
    const brId = parseInt(branchId);

    this.setState({ status: "loading" });

    try {
      const [leadsRes, employeesRes, statusRes] = await Promise.all([
        client.query({
          query: GET_UNASSIGNED_AND_ASSIGNED_LEADS,
          variables: { instituteId: instId, branchId: brId },
          fetchPolicy: "network-only",
        }),
        client.query({
          query: GET_LEAD_MANAGEMENT_EMPLOYEES,
          variables: { instituteId: instId, branchId: brId },
          fetchPolicy: "network-only",
        }),
        client.query({
          query: GET_LEAD_STATUS_TYPES,
          variables: { instituteId: instId },
          fetchPolicy: "network-only",
        }),
      ]);

      console.log("Leads Response:", leadsRes.data);

      const leadData = (leadsRes.data && leadsRes.data.getUnassignedAndAssignedLeads && leadsRes.data.getUnassignedAndAssignedLeads[0]) 
        || { unAssigned_Leads: [], assigned_Leads: [] };
      
      this.setState({
        unassignedLeads: leadData.unAssigned_Leads || [],
        assignedLeads: leadData.assigned_Leads || [],
        employees: employeesRes.data.getLeadManagementEmployees || [],
        statusTypes: statusRes.data.getLeadStatusTypes || [],
        status: "succeeded",
      });
    } catch (error) {
      console.error("Error fetching lead data:", error);
      this.setState({
        status: "failed",
        error: error.message,
        snackbar: { open: true, message: "Failed to load data: " + error.message, severity: "error" },
      });
    }
  };

  handleAssignLeads = async () => {
    const { client } = this.props;
    const { selectedLeads, selectedEmployee } = this.state;
    const userId = parseInt(Cookies.get("id")) || parseInt(Cookies.get("employee_id"));

    if (selectedLeads.length === 0) {
      this.setState({ snackbar: { open: true, message: "Please select leads to assign", severity: "warning" } });
      return;
    }

    if (!selectedEmployee) {
      this.setState({ snackbar: { open: true, message: "Please select an employee", severity: "warning" } });
      return;
    }

    this.setState({ assigning: true });

    try {
      const response = await client.mutate({
        mutation: ADD_OR_DELETE_LEADS,
        variables: {
          params: {
            type: 1, // Add/Assign
            assigned_emp_id: parseInt(selectedEmployee.value),
            inserted_by: userId,
            lead_detatils: selectedLeads.map(id => ({ lead_id: parseInt(id) })),
          },
        },
      });

      if (response.data.addOrDeleteLeads) {
        this.setState({
          selectedLeads: [],
          selectedEmployee: null,
          snackbar: { open: true, message: `Successfully assigned ${selectedLeads.length} leads`, severity: "success" },
        });
        await this.fetchData();
      }
    } catch (error) {
      console.error("Error assigning leads:", error);
      this.setState({
        snackbar: { open: true, message: "Failed to assign leads", severity: "error" },
      });
    } finally {
      this.setState({ assigning: false });
    }
  };

  handleSelectLead = (leadId) => {
    this.setState(prevState => {
      const { selectedLeads } = prevState;
      if (selectedLeads.includes(leadId)) {
        return { selectedLeads: selectedLeads.filter(id => id !== leadId) };
      } else {
        return { selectedLeads: [...selectedLeads, leadId] };
      }
    });
  };

  handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const filteredLeads = this.getFilteredLeads();
      this.setState({ selectedLeads: filteredLeads.map(l => l.lead_id) });
    } else {
      this.setState({ selectedLeads: [] });
    }
  };

  getFilteredLeads = () => {
    const { unassignedLeads, assignedLeads, selectedLeadStatus } = this.state;
    return selectedLeadStatus === "unassigned" ? unassignedLeads : assignedLeads;
  };

  getTableColumns = (filteredLeads) => [
    {
      dataField: "lead_id",
      text: "Select",
      headerFormatter: () => (
        <Form.Check
          type="checkbox"
          checked={filteredLeads.length > 0 && this.state.selectedLeads.length === filteredLeads.length}
          onChange={this.handleSelectAll}
        />
      ),
      formatter: (cell) => (
        <Form.Check
          type="checkbox"
          checked={this.state.selectedLeads.includes(cell)}
          onChange={() => this.handleSelectLead(cell)}
        />
      ),
    },
    { dataField: "lead_name", text: "Lead Name" },
    { dataField: "lead_mobile", text: "Mobile" },
    {
      dataField: "source_name", text: "Source",
      formatter: (cell) => <span className="badge bg-light text-dark border">{cell}</span>,
    },
    {
      dataField: "employee_name", text: "Current Assignment",
      formatter: (cell) => cell ? (
        <div className="d-flex align-items-center gap-2">
          <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "24px", height: "24px", fontSize: "10px" }}>
            {(cell || " ").charAt(0)}
          </div>
          {cell}
        </div>
      ) : <span className="text-muted small">Not Assigned</span>,
    },
    {
      dataField: "assigned_status", text: "Status",
      formatter: (cell, row) => (
        <span className={`badge ${this.state.selectedLeadStatus === "unassigned" ? "bg-warning" : "bg-success"}`}>
          {this.state.selectedLeadStatus === "unassigned" ? "Pending" : "Assigned"}
        </span>
      ),
    },
  ];

  getStatusLabel = (status) => {
    const statusMap = {
      unassigned: "Unassigned Leads",
      assigned: "Assigned Leads",
    };
    return statusMap[status] || status;
  };

  handleEmployeeChange = (name, value, selectedOption) => {
    this.setState({ selectedEmployee: selectedOption });
  };

  render() {
    const {
      status,
      snackbar,
      selectedLeadStatus,
      selectedLeads,
      employees,
      selectedEmployee,
      assigning,
    } = this.state;

    const filteredLeads = this.getFilteredLeads();
    const employeeOptions = (employees || []).map(emp => ({
      value: emp.employee_id,
      label: `${emp.employee_name} (${emp.assigned_status})`
    }));

    return (
      <Container fluid className="px-0">
        {status === "loading" && (
          <div className="d-flex justify-content-center my-5">
            <CircularLoader color="success" />
          </div>
        )}

        {status === "succeeded" && (
          <>
            {/* Action Bar */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
              <div className="d-flex gap-4">
                {["unassigned", "assigned"].map((status) => (
                  <label
                    key={status}
                    className="d-flex align-items-center gap-2 mb-0"
                    style={{ cursor: "pointer", fontSize: "15px", fontWeight: 600, color: selectedLeadStatus === status ? THEME.primary : THEME.textMuted }}
                  >
                    <input
                      type="radio"
                      name="leadStatus"
                      value={status}
                      checked={selectedLeadStatus === status}
                      onChange={(e) => this.setState({ selectedLeadStatus: e.target.value, selectedLeads: [] })}
                      style={{ width: "18px", height: "18px", cursor: "pointer" }}
                    />
                    {this.getStatusLabel(status)}
                  </label>
                ))}
              </div>

              {selectedLeads.length > 0 && selectedLeadStatus === "unassigned" && (
                <div className="d-flex align-items-center gap-3 p-2 bg-light rounded shadow-sm border border-primary animate__animated animate__fadeInDown">
                  <span className="fw-bold text-primary px-2">
                    {selectedLeads.length} Selected
                  </span>
                  <div style={{ width: "250px" }}>
                    <SelectDropDown
                      name="employee"
                      placeholderName="Assign to Employee..."
                      options={employeeOptions}
                      stateData={selectedEmployee}
                      handleChange={this.handleEmployeeChange}
                    />
                  </div>
                  <Button 
                    variant="primary" 
                    size="sm" 
                    disabled={assigning || !selectedEmployee}
                    onClick={this.handleAssignLeads}
                    className="px-4 py-2"
                  >
                    {assigning ? "Assigning..." : "Assign Now"}
                  </Button>
                </div>
              )}
            </div>

            {/* Refresh */}
            <div className="d-flex justify-content-end mb-3">
              <Button variant="outline-secondary" size="sm" onClick={() => this.fetchData()} title="Refresh Data">
                <i className="fas fa-sync-alt"></i> Refresh
              </Button>
            </div>

            {/* Leads Table */}
            <CardLessDataTableWithSearch
              parentData={filteredLeads.map(lead => ({ ...lead, id: lead.lead_id }))}
              particlecolumns={this.getTableColumns(filteredLeads)}
              defaultSorted={[{ dataField: "lead_name", order: "asc" }]}
              name="leads"
            />
          </>
        )}

        <SnackbarMessage
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={() => this.setState({ snackbar: { open: false, message: "", severity: "success" } })}
        />
      </Container>
    );
  }
}

export default withApollo(TagsList);
